module.exports = __webpack_public_path__ + "static/media/chrome.bb4352de.png";